import React, { useEffect, useState } from "react";
import QrLogin from "./QrLogin";
import UserProfileModal from "./UserProfileModal";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { jwtDecode } from 'jwt-decode'; // ✅ Correct
import logoImage from "../assets/LU-2026--Main-Revised.png";


let hasFetchedGlobalFlag = false; // Outside component to survive strict mode unmounts

const LU_RED = "#FF0000";

const Navbar = () => {
  const styles = {
    container: {
      margin: "0px 40px",
    },
    navbar: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 36px",
      backgroundColor: "rgba(255, 255, 255, 0.94)",
      backdropFilter: "none",
      WebkitBackdropFilter: "none",
      borderBottom: "1px solid rgba(0, 0, 0, 0.04)",
      position: "sticky",
      top: 12,
      margin: "0 12px",
      zIndex: 1100,
      transition: "all 0.25s ease",
      boxShadow: "0 8px 30px rgba(2,6,23,0.04)",
      borderRadius: "12px",
    },
    logo: {
      color: "#000",
      fontSize: "20px",
      fontWeight: "800",
      letterSpacing: "-0.5px",
      cursor: "pointer",
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
    },
    loginbtn: {
      backgroundColor: "#FF0000",
      padding: "10px 20px",
      border: "none",
      borderRadius: "999px",
      fontSize: "14px",
      fontWeight: "800",
      cursor: "pointer",
      textDecoration: "none",
      color: "white",
      boxShadow: "0 8px 30px rgba(255, 0, 0, 0.18)",
      transition: "transform 0.18s ease, box-shadow 0.18s ease",
    },
    navLinks: {
      display: "flex",
      gap: "28px",
      alignItems: "center",
    },
    link: {
      color: "#0f172a",
      textDecoration: "none",
      fontSize: "14px",
      fontWeight: "600",
      letterSpacing: "0px",
      cursor: "pointer",
      transition: "color 0.15s ease, transform 0.15s ease",
    },
    avatar: {
      height: "35px",
      width: "35px",
      borderRadius: "50%",
      backgroundColor: "#666",
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "16px",
      fontWeight: "bold",
      cursor: "pointer",
    },
    popup: {
      position: "absolute",
      right: "10px",
      top: "50px",
      padding: "10px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      textAlign: "center",
    },
    button: {
      marginTop: "10px",
      padding: "10px 20px",
      backgroundColor: "#0A1F3B",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
  };

  const [isLoginVisible, setIsLoginVisible] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState("");
  const [data, setData] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const navigate = useNavigate();

  const handleLoginButtonClick = () => {
    setIsLoginVisible(true);
  };

  const handleCloseLoginForm = () => {
    setIsLoginVisible(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("Authenticated");
    localStorage.removeItem("data");
    setIsLoggedIn("");
    setData("");
  };

  // --- LEGITIMATELY UNIVERSAL SDK (SSO Redirect Handler) ---
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    console.log("code--", code)

    if (code && !hasFetchedGlobalFlag) {
      hasFetchedGlobalFlag = true;
      setIsVerifying(true);
      const LEGIT_CLIENT_ID = "2307586";
      const REDIRECT_URI = window.location.origin + window.location.pathname;

      fetch("https://api.legitimatelyu.com/api/v1/user/oauth/token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          client_id: LEGIT_CLIENT_ID,
          code: code,
        }),
      })
        .then((response) => response.json())
        .then((resp) => {
          console.log("FULL BACKEND RESPONSE:", resp);

          if (resp.success && resp.result) {
            const { access_token, user } = resp.result;

            const dataToStore = {
              user: {
                ...user,
                user_token: access_token
              }
            };

            localStorage.setItem("Authenticated", "true");
            localStorage.setItem("data", JSON.stringify(dataToStore));

            setIsLoggedIn("true");

            try {
              const decodedJwt = jwtDecode(access_token);
              setData({ ...user, ...decodedJwt });
            } catch (e) {
              setData(user);
            }

            window.history.replaceState({}, document.title, REDIRECT_URI);
          } else {
            console.error("Unexpected response shape from SSO login:", resp);
          }
        })
        .catch((err) => console.error("SSO Failed", err))
        .finally(() => setIsVerifying(false));
    }
  }, []);

  useEffect(() => {
    const checkLoginStatus = () => {
      try {
        const authStatus = localStorage.getItem("Authenticated");
        const storedData = localStorage.getItem("data");
        let decoded = "";

        if (storedData) {
          const parsedData = JSON.parse(storedData);
          // Only attempt to decode if user_token exists and is a string
          if (parsedData?.user?.user_token && typeof parsedData.user.user_token === "string") {
            const decodedJwt = jwtDecode(parsedData.user.user_token);
            decoded = { ...parsedData.user, ...decodedJwt }; // Combine to keep full_name
          } else {
            // If there's no token to decode, we can just use the user object directly
            decoded = parsedData?.user || "";
          }
        }

        setIsLoggedIn(authStatus);
        setData(decoded);
      } catch (err) {
        console.error("Error decoding token:", err);
      }
    };

    checkLoginStatus();
  }, []);

  const handleLinkClick = (e, sectionTitle) => {
    e.preventDefault();
    navigate("/video", { state: { sectionTitle, num: 0 } });
  };

  console.log("data", data)

  return (
    <div>
      <style>
        {`
          .nav-link:hover {
            color: #ff0000 !important;
          }
          .login-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(255, 0, 0, 0.3) !important;
            background-color: #e60000 !important;
          }
          .login-btn:active {
            transform: translateY(0);
          }
              .nav-link {
                padding: 6px 4px;
                border-radius: 6px;
              }
              .nav-link:hover {
                background: rgba(255,0,0,0.04);
                transform: translateY(-2px);
                color: #ff0000 !important;
              }
              .dropdown:hover .dropdown-menu { display: block; }
              .dropdown-menu a:hover { background: rgba(2,6,23,0.02); transform: translateY(-2px); }
        `}
      </style>
      <div style={styles.navbar} className="navbar">
        <a style={styles.logo} href="/">
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {/* Icon: show only the LU badge portion of the square PNG */}
            <img
              src={logoImage}
              alt="LU"
              style={{ height: "36px", width: "36px", objectFit: "cover", objectPosition: "13% center", borderRadius: "8px" }}
            />
            <span style={{ fontWeight: 900, fontSize: "16px", color: LU_RED, letterSpacing: "0.5px" }}>
              LEGITIMATELY U
            </span>
          </div>
        </a>
        <div style={styles.navLinks}>
          <a style={styles.link} className="nav-link" href="/">
            Home
          </a>
          <div style={{ position: "relative" }} className="dropdown">
            <a style={{ ...styles.link, display: "inline-flex", alignItems: "center", gap: 8 }} className="nav-link" href="/#platforms" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => { const el = document.getElementById('platforms'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 120); }}>
              Portals ▾
            </a>
            <div className="dropdown-menu" style={{ display: "none", position: "absolute", top: "36px", left: 0, background: "#fff", border: "1px solid rgba(2,6,23,0.06)", borderRadius: 8, boxShadow: "0 10px 30px rgba(2,6,23,0.08)", padding: 8, minWidth: 180, zIndex: 1200 }}>
              {[
                { id: 'finance', label: 'Finance' },
                { id: 'healthcare', label: 'Healthcare' },
                { id: 'insurance', label: 'Insurance' },
                { id: 'government', label: 'Government' },
                { id: 'corporate', label: 'Corporate' }
              ].map(item => (
                <a key={item.id} href={`/#${item.id}`} className="nav-link" onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => { const el = document.getElementById(item.id); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 150); }} style={{ display: 'block', padding: '8px 10px', color: '#0f172a', textDecoration: 'none', borderRadius: 6 }}>{item.label}</a>
              ))}
            </div>
          </div>
          <a
            style={styles.link}
            className="nav-link"
            href="/video"
            onClick={(e) => handleLinkClick(e, "Security Features")}
          >
            Security Features
          </a>
          <a
            style={styles.link}
            className="nav-link"
            href="/video"
            onClick={(e) => handleLinkClick(e, "Integration Guides")}
          >
            Integration
          </a>
          <a
            style={styles.link}
            className="nav-link"
            href="/#case-studies"
            onClick={(e) => {
              e.preventDefault();
              navigate("/");
              setTimeout(() => {
                const el = document.getElementById("case-studies");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }, 100);
            }}
          >
            Case Studies
          </a>
        </div>
        <div>
          {isVerifying ? (
            <div style={{ ...styles.loginbtn, cursor: "wait", opacity: 0.8 }}>
              <Spin size="small" style={{ marginRight: "8px" }} /> Verifying...
            </div>
          ) : isLoggedIn === "true" ? (
            <UserProfileModal
              setIsLoginVisible={setIsLoginVisible}
              data={data}
              handleLogout={handleLogout}
            />
          ) : (
            <div style={styles.loginbtn} className="login-btn" onClick={handleLoginButtonClick}>
              Log In
            </div>
          )}
          <QrLogin onLogin={isLoginVisible} onSkip={handleCloseLoginForm} setMainData={setData} />
        </div>
      </div>
    </div>
  );
};

export default Navbar;